import React from 'react'
import ReadMoreButton from '../../../read-more-button'
import { HaulerAppStoreButtons } from '../../../hauler-app-store-buttons'
import { YoutubeMonitor } from '../../../youtube-monitor'

export const AboutSection = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="row content">
          <div className="col-lg-6">
            <h2>Mobile App Ticket Data Entry</h2>

            <h3>
              The first simple and affordable mobile data entry system for any milk hauling organization. Operating on both Android or iPhone/iPad
              systems
            </h3>

            <div>
              <HaulerAppStoreButtons />
            </div>

            <ReadMoreButton url="/docs/posts/getting-started-with-hauler" />
          </div>
          <div className="col-lg-6 pt-4 pt-lg-0">
            <YoutubeMonitor youtubeId="Av3q5fwcbcg" />
          </div>
        </div>
      </div>
    </section>
  )
}
